import { render, staticRenderFns } from "./tabObjectGoodsSummary.vue?vue&type=template&id=194a96ff&"
import script from "./tabObjectGoodsSummary.vue?vue&type=script&lang=js&"
export * from "./tabObjectGoodsSummary.vue?vue&type=script&lang=js&"
import style0 from "./tabObjectGoodsSummary.vue?vue&type=style&index=0&id=194a96ff&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports